<template>
  <transition name="fade">
    <div v-if="show" class="pop_back" @click="$emit('close')">
      <div class="pop_payment_method_select" @click="$event.stopPropagation()">
        <div class="head">
          <h1>{{ $t("payment_method_select.title") }}</h1>
          <a href="javascript:" @click="$emit('close')">
            <img src="../../../assets/img/btn_close.png" />
          </a>
        </div>
        <div class="content">
          <div class="section">
            <div class="header" @click="onTotalPaymentClick()">
              <span class="header_title">{{
                $t("payment_method_select.total_payment")
              }}</span>
              <img src="../../../assets/img/down_arrow_gray.png" />
            </div>
            <span class="price">Rp {{ price }}</span>

            <div v-if="!totalPaymentCollapsed">
              <div
                style="
                  width: 100%;
                  height: 1px;
                  background-color: #dddddd;
                  margin-top: 20px;
                  margin-bottom: 20px;
                "
              ></div>

              <span>{{ $t("payment_method_select.order_details") }}</span>
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  margin-top: 20px;
                "
              >
                <span class="order_id"
                  >{{ $t("payment_method_select.order_id") }}:
                  {{ orderId }}</span
                >
                <img src="../../../assets/img/copy.png" @click="onCopy()" />
              </div>
              <span class="order_id"
                >{{ $t("payment_method_select.item_points") }}:
                {{ point }} P</span
              >
            </div>
          </div>

          <div v-if="lastItem != null" style="margin-top: 30px">
            <span class="label">{{
              $t("payment_method_select.last_payment_method")
            }}</span>
            <div
              class="section"
              style="margin-top: 20px"
              @click="onItemClick(lastItem, 0)"
            >
              <div class="header" style="margin: 0px">
                <img
                  :src="
                    require(`../../../assets/img/${lastItem.productCode}.png`)
                  "
                  style="width: 60px; height: 20px"
                />
                <span
                  class="header_title"
                  style="flex-grow: 1; margin-left: 12px"
                  >{{ lastItem.productName }}</span
                >
                <img src="../../../assets/img/right_arrow_gray.png" />
              </div>
            </div>
          </div>

          <span class="label">{{
            $t("payment_method_select.all_payment_method")
          }}</span>
          <PaymentMethodGroup
            :title="$t('payment_method_select.virtual_account')"
            :pg_list="PG_VIRTUAL_ACCOUNT_ITEMS"
            style="margin-top: 10px; margin-bottom: 10px"
            @onItemClick="onItemClick"
          />
          <PaymentMethodGroup
            :title="$t('payment_method_select.ewallet')"
            :pg_list="PG_EWALLET_ITEMS"
            style="margin-bottom: 10px"
            @onItemClick="onItemClick"
          />
          <PaymentMethodGroup
            :title="$t('payment_method_select.booth')"
            :pg_list="PG_BOOTH_ITEMS"
            style="margin-bottom: 10px"
            @onItemClick="onItemClick"
          />
          <PaymentMethodGroup
            :title="$t('payment_method_select.other')"
            :pg_list="PG_OTHER_ITEMS"
            @onItemClick="onItemClick"
          />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import PaymentMethodGroup from "./PaymentMethodGroup.vue";
import {
  PG_VIRTUAL_ACCOUNT_ITEMS,
  PG_EWALLET_ITEMS,
  PG_BOOTH_ITEMS,
  PG_OTHER_ITEMS,
} from "../../../lib/constant";

export default {
  name: "PaymentMethodSelectPopup",
  components: {
    PaymentMethodGroup,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    point: {
      type: String,
    },
    price: {
      type: String,
    },
    orderId: {
      type: String,
    },
  },
  emits: ["close", "selected"],
  data() {
    return {
      backButtonRouteGuard: null,
      totalPaymentCollapsed: true,
      PG_VIRTUAL_ACCOUNT_ITEMS,
      PG_EWALLET_ITEMS,
      PG_BOOTH_ITEMS,
      PG_OTHER_ITEMS,
      lastItem: null,
    };
  },
  computed: {},
  watch: {
    show(show) {
      if (show) {
        let lastPaymentMethodItem = window.localStorage.getItem(
          "LastPaymentMethodItem"
        );
        if (lastPaymentMethodItem != null) {
          this.lastItem = JSON.parse(lastPaymentMethodItem);
        }

        // dialog show
        document.addEventListener("keyup", this.onKeyPress);
        // back button
        this.backButtonRouteGuard = this.$router.beforeEach(
          (to, from, next) => {
            this.$emit("close");
            next(false);
          }
        );
      } else {
        // dialog hide
        document.removeEventListener("keyup", this.onKeyPress);
        // back button
        if (this.backButtonRouteGuard) {
          this.backButtonRouteGuard();
        }
      }
    },
  },
  methods: {
    onKeyPress: function (e) {
      if (e.keyCode == 27) {
        let me = document.querySelector(
          ".pop_payment_method_select"
        ).parentElement;
        let activeDlgList = document.querySelectorAll(".pop_back");

        if (activeDlgList.item(activeDlgList.length - 1) == me) {
          this.$emit("close");
        }
      }
    },
    onTotalPaymentClick: function () {
      this.totalPaymentCollapsed = !this.totalPaymentCollapsed;
    },
    onCopy: function () {
      navigator.clipboard.writeText(orderId);
    },
    onItemClick: function (item, index) {
      window.localStorage.setItem(
        "LastPaymentMethodItem",
        JSON.stringify(item)
      );
      this.$emit("selected", item);
    },
  },
};
</script>

<style scoped>
.pop_payment_method_select {
  position: fixed;
  width: 400px;
  height: 500px;
  left: 50%;
  top: 50%;
  margin-left: -240px;
  margin-top: -250px;
  padding: 40px;
  background-color: white;
  border-radius: 15px;
  z-index: 110;
}

.pop_payment_method_select .head {
  position: relative;
  padding-bottom: 20px;
  border-bottom: solid 1px #e5e5e5;
}

.pop_payment_method_select .head h1 {
  font-size: 18px;
  line-height: 20px;
}

.pop_payment_method_select .head a {
  position: absolute;
  right: 0;
  top: 0;
}

.pop_payment_method_select .head a img {
  width: 20px;
  opacity: 0.5;
}

.pop_payment_method_select .content {
  position: relative;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 450px;
  overflow-y: scroll;
}

.pop_payment_method_select .content .section {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 26px;
  background-color: #f9f9f9;
  border-radius: 18px;
}

.pop_payment_method_select .content .label {
  font-size: 16px;
  font-weight: 300;
  color: black;
  margin-top: 30px;
  margin-bottom: 20px;
}

.pop_payment_method_select .content .section .header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0px 0px 20px 0px;
}

.header_title {
  font-size: 16px;
  font-weight: 500;
}

.price {
  font-size: 32px;
  font-weight: bold;
}

.order_id {
  font-size: 14px;
  font-weight: normal;
  color: #9a9a9a;
}

@media only screen and (max-width: 766px) {
  .pop_payment_method_select {
    width: calc(100% - 40px);
    height: 650px;
    left: 0;
    bottom: 0;
    top: auto;
    margin-left: 0;
    margin-top: 0;
    padding: 20px;
    border-radius: 15px;
    z-index: 101;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .pop_payment_method_select .content {
    position: relative;
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 500px;
    overflow-y: scroll;
  }
}
</style>
